<template>
  <div>
    <div>
      <div class="project-search">
        <div class="flex search-text align-center">
          <div>
            <span>名称：</span>
            <input v-model="pageInfo.name" placeholder="实验室名称" class="searchInput" />
          </div>
          <button class="searchBtn" @click="search">搜索</button>
          <button class="resetBtn" @click="reset(null)">重置</button>
        </div>
      </div>
      <div class="project-table" style="margin-top: 20px">
        <div class="flex align-center justify-between paddingBTM20">
          <div class="fontSize20gay">实验室列表</div>
          <div class="flex">
            <div>
              <el-upload class="upload-demo" :action="'/'+$root.projectName + '/laboratory/import?Authorization=Bearer '+token" list-type="picture" :show-file-list="false" :on-success="fileVb">
                <button class="exportBtn">导入</button>
              </el-upload>
            </div>
            <button class="exportBtn marginLR10" @click="showDown('laboratory')">下载模板</button>
            <button class="addBtn" @click="showEdit('')"> + 新增</button>
          </div>
        </div>
        <el-table :data="tableData" border row-key="id"
                  :header-cell-style="{'text-align':'center','color':'#999999','padding':'16px 0','background-color':'#EBEBEB'}"
                  :cell-style="{'text-align':'center'}">
          <el-table-column prop="code" label="编号" />
          <el-table-column prop="name" label="实验室名称" />
          <el-table-column label="所属楼栋">
            <template #default="scope"><!-- scope.$index 表示 序列号 0、1、2 -->
              {{scope.row.building?scope.row.building.name:''}}
            </template>
          </el-table-column>
          <el-table-column prop="address" label="地点" />
          <el-table-column prop="userNames" label="管理员" show-overflow-tooltip />
          <el-table-column prop="time" label="创建时间" />
          <el-table-column prop="time" label="是否开放预约">
            <template #default="scope"><!-- scope.$index 表示 序列号 0、1、2 -->
              <span class="fontSize12" :class="scope.row.open?'success':'error'">●</span><span class="marginLeft5">{{scope.row.open?'开放':'未开放'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="time" label="是否对学生开放">
            <template #default="scope"><!-- scope.$index 表示 序列号 0、1、2 -->
              <span class="fontSize12" :class="scope.row.openStudent?'success':'error'">●</span><span class="marginLeft5">{{scope.row.open?'开放':'未开放'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="useSize" label="已用课时" />
          <el-table-column label="使用率">
            <template #default="scope"><!-- scope.$index 表示 序列号 0、1、2 -->
              {{scope.row.usageTate}}%
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="150">
            <template #default="scope"><!-- scope.$index 表示 序列号 0、1、2 -->
              <el-button link type="primary" style="color: #3769B9" @click="showEdit(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="flex justify-center paddingTD20">
          <!--   分页     -->
          <el-pagination
              :currentPage="pageInfo.page"
              :page-size="pageInfo.limit"
              :page-sizes="[10, 20, 50, 100]"
              :small="true"
              :disabled="false"
              :background="true"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageInfo.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
    <!-- 操作窗口   -->
  </div>
</template>

<script>
import {getRoomPage,getMyRoomPage,downFile} from "@/api/api";
export default {
  name: "roomList",
  data(){
    return{
      token:localStorage.getItem('token'),
      user:localStorage.getItem('user'),
      tableData:[],
      dataInfo:[],
      Info:null,
      dialogFormVisible:false,
      pageInfo:{
        limit:10,
        name:'',
        page:1,
        total:0
      },
      exportIds:''
    }
  },
  mounted() {
    this.getList();
  },
  methods:{
    reset(){
      this.pageInfo.name=''
    },
    search(){
      this.pageInfo.limit=10;
      this.pageInfo.page=1;
      this.getList();
    },
    getList(){
      getMyRoomPage(this.pageInfo).then(res=>{
        this.pageInfo.total=parseInt(res.data.total);
        this.tableData=res.data.records;
      })
    },
    showEdit(row){
      this.Info=row;
      let data='';
      if(row) {
        data = JSON.stringify(this.Info);
      }
      this.$root.useRouter.push({path:"/room/roomEdit",query:{info:data}});
    },
    showRenew(id){
      this.dialogFormVisible1=true;
      this.$refs.renewDiv.getInfo(id);//调用子组件方法
    },
    closeDiv(){
      this.dialogFormVisible=false;
    },
    handleSizeChange(e){//修改每页显示条数
      this.pageInfo.limit=e;
      this.pageInfo.page=1;
      this.getList();
    },
    handleCurrentChange(e){
      this.pageInfo.page=e;
      this.getList();
    },
    showDown(name){
      downFile(name);
    },
    fileVb(res){
      if(res.success){
        this.$root.ElMessage({type:'success',message:res.message});
        this.getList();
      }else{
        this.$root.ElMessage.error(res.message);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.data-title{font-size: 15px;color: #000000}
.data-content{
  font-size: 13px;display: flex;justify-content: space-between;margin-top: 15px;
}
</style>